import { apiSlice } from "../api/apiSlice";

export const teamsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeam: builder.query({
      query: (data) => {
        const { id, convertedTeamName } = data || {};
        let queryString = "";
        if (id) queryString = `/teams/${id}`;
        else queryString = `/teams?teamName=${convertedTeamName}`;
        return {
          url: queryString,
          method: "GET",
        };
      },
    }),
    getAllTeams: builder.query({
      query: ({ email, all }) => {
        return {
          url: `/teams/`,
          method: "GET",
        };
      },
      providesTags: ["Teams"],
      transformResponse(apiResponse, meta, arg) {
        if (arg.email) {
          let newResponse = [];
          for (const obj1 of apiResponse) {
            for (const obj2 of obj1.teamMembers) {
              if (obj2.email === arg.email) {
                newResponse.push(obj1);
              }
            }
          }
          return newResponse;
        }
        if (arg.all) {
          return apiResponse.map((res) => ({
            id: res.id,
            teamName: res.teamName,
            teamColor: res.teamColor,
          }));
        }
      },
    }),
    createTeam: builder.mutation({
      query: (body) => {
        return {
          url: `/teams/`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Teams"],
    }),
    editTeam: builder.mutation({
      query: ({ body, id }) => {
        return {
          url: `/teams/${id}`,
          method: "PATCH",
          body,
        };
      },
      invalidatesTags: ["Teams"],
    }),
  }),
});

export const {
  useGetTeamQuery,
  useGetAllTeamsQuery,
  useCreateTeamMutation,
  useEditTeamMutation,
} = teamsApi;
